<template>
  <div v-if="dashData" class="row">
    <h3 class="mb-20">Statistiques Générals</h3>

    <div class="col-md-3 col-sm-6">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center"
              :style="{
                color:
                  dashData?.ParcelsStatus?.NEW_PARCEL?.color + ' !important',
              }"
            >
              <i class="flaticon-sterile-box"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
                {{
                  dashData?.ParcelsStatus?.NEW_PARCEL?.name ?? "Nouveaux Colis"
                }}
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ dashData?.ParcelsStatus?.NEW_PARCEL?.num ?? 0 }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Repeat for other statuses as before, using ?. for safe access -->
    <div class="col-md-3 col-sm-6">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center"
              :style="{
                color:
                  dashData?.ParcelsStatus?.WAITING_PICKUP?.color +
                  ' !important',
              }"
            >
              <i class="flaticon-sterile-box"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
                {{
                  dashData?.ParcelsStatus?.WAITING_PICKUP?.name ??
                  "En Attente de Ramassage"
                }}
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ dashData?.ParcelsStatus?.WAITING_PICKUP?.num ?? 0 }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ...repeat for all other statuses, using ?. for safe access... -->
    <div class="col-md-3 col-sm-6">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center"
              :style="{
                color:
                  dashData?.ParcelsStatus?.PICKED_UP?.color + ' !important',
              }"
            >
              <i class="flaticon-sterile-box"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
                {{
                  dashData?.ParcelsStatus?.PICKED_UP?.name ?? "Colis Ramassés"
                }}
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ dashData?.ParcelsStatus?.PICKED_UP?.num ?? 0 }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3 col-sm-6">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center"
              :style="{
                color:
                  dashData?.ParcelsStatus?.DISTRIBUTION?.color + ' !important',
              }"
            >
              <i class="flaticon-sterile-box"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
                {{
                  dashData?.ParcelsStatus?.DISTRIBUTION?.name ??
                  "En Distribution"
                }}
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ dashData?.ParcelsStatus?.DISTRIBUTION?.num ?? 0 }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3 col-sm-6">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center"
              :style="{
                color:
                  dashData?.ParcelsStatus?.IN_PROGRESS?.color + ' !important',
              }"
            >
              <i class="flaticon-sterile-box"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
                {{ dashData?.ParcelsStatus?.IN_PROGRESS?.name ?? "En Cours" }}
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ dashData?.ParcelsStatus?.IN_PROGRESS?.num ?? 0 }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3 col-sm-6">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center"
              :style="{
                color:
                  dashData?.ParcelsStatus?.DELIVERED?.color + ' !important',
              }"
            >
              <i class="flaticon-sterile-box"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
                {{ dashData?.ParcelsStatus?.DELIVERED?.name ?? "Livrés" }}
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ dashData?.ParcelsStatus?.DELIVERED?.num ?? 0 }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3 col-sm-6">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center"
              :style="{
                color: dashData?.ParcelsStatus?.REFUSE?.color + ' !important',
              }"
            >
              <i class="flaticon-sterile-box"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
                {{ dashData?.ParcelsStatus?.REFUSE?.name ?? "Refusés" }}
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ dashData?.ParcelsStatus?.REFUSE?.num ?? 0 }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3 col-sm-6">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center"
              :style="{
                color: dashData?.ParcelsStatus?.RETURNED?.color + ' !important',
              }"
            >
              <i class="flaticon-sterile-box"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
                {{ dashData?.ParcelsStatus?.RETURNED?.name ?? "Retournés" }}
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ dashData?.ParcelsStatus?.RETURNED?.num ?? 0 }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="card mb-25 border-0 rounded-0 mb-20">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <div
            class="mb-15 mb-sm-0 d-sm-flex align-items-center justify-content-between"
          >
            <div class="title">
              <h5 class="card-title fw-black mb-0">
                {{ dashData?.totalParcels }} Colis
              </h5>
            </div>
          </div>
          <div class="col-md-8">
            <div>
              <div class="chart">
                <apexchart
                  type="line"
                  height="325"
                  :options="statisticsProfit.chartOptions"
                  :series="chartData"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="card mb-25 border-0 rounded-0 bg-white">
          <div class="card-header">
            <h6 class="card-title">Total Bons Paiment Payé (Livreur)</h6>
            <h6 class="mb-25 fw-black">
              {{ dashData?.totalNotePaid ?? 0 }} Bons
            </h6>
          </div>
          <div class="card-body">
            <div
              class="mb-20 d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center">
                <div
                  class="icon position-relative rounded-circle text-center bg-success text-white me-15"
                  style="
                    width: 42px;
                    height: 42px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <i class="flaticon-sterile-box"></i>
                </div>
                <div>
                  <h6 class="mb-0 fw-medium">Colis</h6>
                  <small class="text-muted">Total Colis</small>
                </div>
              </div>
              <div class="fw-black">
                {{ dashData?.payn_l_parcels ?? 0 }} Colis
              </div>
            </div>
            <div
              class="mb-20 d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center">
                <div
                  class="icon position-relative rounded-circle text-center bg-danger text-white me-15"
                  style="
                    width: 42px;
                    height: 42px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <i class="flaticon-money"></i>
                </div>
                <div>
                  <h6 class="mb-0 fw-medium">Crbt</h6>
                  <small class="text-muted">Total Crbt</small>
                </div>
              </div>
              <div class="fw-black">
                {{ dashData?.payn_l_crbt ?? 0 }}
                {{ dashData?.devis?.devis ?? "" }}
              </div>
            </div>
            <div
              class="mb-20 d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center">
                <div
                  class="icon position-relative rounded-circle text-center bg-primary text-white me-15"
                  style="
                    width: 42px;
                    height: 42px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <i class="flaticon-express-delivery"></i>
                </div>
                <div>
                  <h6 class="mb-0 fw-medium">Frais</h6>
                  <small class="text-muted">Total Frais</small>
                </div>
              </div>
              <div class="fw-black">
                {{ dashData?.payn_l_fees ?? 0 }}
                {{ dashData?.devis?.devis ?? "" }}
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div
                  class="icon position-relative rounded-circle text-center bg-info text-white me-15"
                  style="
                    width: 42px;
                    height: 42px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <i class="flaticon-money"></i>
                </div>
                <div>
                  <h6 class="mb-0 fw-medium">Total</h6>
                  <small class="text-muted">Total</small>
                </div>
              </div>
              <div class="fw-black text-danger">
                {{ dashData?.payn_l_total ?? 0 }}
                {{ dashData?.devis?.devis ?? "" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card mb-25 border-0 rounded-0 bg-white">
          <div class="card-header">
            <h6 class="card-title">Total Bons Paiment Non Payé (Livreur)</h6>
            <h6 class="mb-25 fw-black">
              {{ dashData?.totalNoteNotPaid ?? 0 }} Bons
            </h6>
          </div>
          <div class="card-body">
            <div
              class="mb-20 d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center">
                <div
                  class="icon position-relative rounded-circle text-center bg-success text-white me-15"
                  style="
                    width: 42px;
                    height: 42px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <i class="flaticon-sterile-box"></i>
                </div>
                <div>
                  <h6 class="mb-0 fw-medium">Colis</h6>
                  <small class="text-muted">Total Colis</small>
                </div>
              </div>
              <div class="fw-black">
                {{ dashData?.payn_l_not_parcels ?? 0 }} Colis
              </div>
            </div>
            <div
              class="mb-20 d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center">
                <div
                  class="icon position-relative rounded-circle text-center bg-danger text-white me-15"
                  style="
                    width: 42px;
                    height: 42px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <i class="flaticon-money"></i>
                </div>
                <div>
                  <h6 class="mb-0 fw-medium">Crbt</h6>
                  <small class="text-muted">Total Crbt</small>
                </div>
              </div>
              <div class="fw-black">
                {{ dashData?.payn_l_not_crbt ?? 0 }}
                {{ dashData?.devis?.devis ?? "" }}
              </div>
            </div>
            <div
              class="mb-20 d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center">
                <div
                  class="icon position-relative rounded-circle text-center bg-primary text-white me-15"
                  style="
                    width: 42px;
                    height: 42px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <i class="flaticon-express-delivery"></i>
                </div>
                <div>
                  <h6 class="mb-0 fw-medium">Frais</h6>
                  <small class="text-muted">Total Frais</small>
                </div>
              </div>
              <div class="fw-black">
                {{ dashData?.payn_l_not_fees ?? 0 }}
                {{ dashData?.devis?.devis ?? "" }}
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div
                  class="icon position-relative rounded-circle text-center bg-info text-white me-15"
                  style="
                    width: 42px;
                    height: 42px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <i class="flaticon-money"></i>
                </div>
                <div>
                  <h6 class="mb-0 fw-medium">Total</h6>
                  <small class="text-muted">Total</small>
                </div>
              </div>
              <div class="fw-black text-danger">
                {{ dashData?.payn_l_not_total ?? 0 }}
                {{ dashData?.devis?.devis ?? "" }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card mb-25 border-0 rounded-0 bg-white">
          <div class="card-header">
            <h6 class="card-title">Total Bons Paiment Payé (Zone)</h6>
            <h6 class="mb-25 fw-black">
              {{ dashData?.totalZNotePaid ?? 0 }} Bons
            </h6>
          </div>
          <div class="card-body">
            <div
              class="mb-20 d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center">
                <div
                  class="icon position-relative rounded-circle text-center bg-success text-white me-15"
                  style="
                    width: 42px;
                    height: 42px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <i class="flaticon-sterile-box"></i>
                </div>
                <div>
                  <h6 class="mb-0 fw-medium">Colis</h6>
                  <small class="text-muted">Total Colis</small>
                </div>
              </div>
              <div class="fw-black">
                {{ dashData?.payn_z_parcels ?? 0 }} Colis
              </div>
            </div>
            <div
              class="mb-20 d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center">
                <div
                  class="icon position-relative rounded-circle text-center bg-primary text-white me-15"
                  style="
                    width: 42px;
                    height: 42px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <i class="flaticon-express-delivery"></i>
                </div>
                <div>
                  <h6 class="mb-0 fw-medium">Frais</h6>
                  <small class="text-muted">Total Frais</small>
                </div>
              </div>
              <div class="fw-black">
                {{ dashData?.payn_z_fees ?? 0 }}
                {{ dashData?.devis?.devis ?? "" }}
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div
                  class="icon position-relative rounded-circle text-center bg-info text-white me-15"
                  style="
                    width: 42px;
                    height: 42px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <i class="flaticon-money"></i>
                </div>
                <div>
                  <h6 class="mb-0 fw-medium">Total</h6>
                  <small class="text-muted">Total</small>
                </div>
              </div>
              <div class="fw-black text-danger">
                {{ dashData?.payn_z_total ?? 0 }}
                {{ dashData?.devis?.devis ?? "" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card mb-25 border-0 rounded-0 bg-white">
          <div class="card-header">
            <h6 class="card-title">Total Bons Paiment Non Payé (Zone)</h6>
            <h6 class="mb-25 fw-black">
              {{ dashData?.totalZNoteNotPaid ?? 0 }} Bons
            </h6>
          </div>
          <div class="card-body">
            <div
              class="mb-20 d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center">
                <div
                  class="icon position-relative rounded-circle text-center bg-success text-white me-15"
                  style="
                    width: 42px;
                    height: 42px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <i class="flaticon-sterile-box"></i>
                </div>
                <div>
                  <h6 class="mb-0 fw-medium">Colis</h6>
                  <small class="text-muted">Total Colis</small>
                </div>
              </div>
              <div class="fw-black">
                {{ dashData?.payn_z_not_parcels ?? 0 }} Colis
              </div>
            </div>
            <div
              class="mb-20 d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center">
                <div
                  class="icon position-relative rounded-circle text-center bg-primary text-white me-15"
                  style="
                    width: 42px;
                    height: 42px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <i class="flaticon-express-delivery"></i>
                </div>
                <div>
                  <h6 class="mb-0 fw-medium">Frais</h6>
                  <small class="text-muted">Total Frais</small>
                </div>
              </div>
              <div class="fw-black">
                {{ dashData?.payn_z_not_fees ?? 0 }}
                {{ dashData?.devis?.devis ?? "" }}
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div
                  class="icon position-relative rounded-circle text-center bg-info text-white me-15"
                  style="
                    width: 42px;
                    height: 42px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <i class="flaticon-money"></i>
                </div>
                <div>
                  <h6 class="mb-0 fw-medium">Total</h6>
                  <small class="text-muted">Total</small>
                </div>
              </div>
              <div class="fw-black text-danger">
                {{ dashData?.payn_z_not_total ?? 0 }}
                {{ dashData?.devis?.devis ?? "" }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div v-if="dashData" class="card mb-25 border-0 rounded-0 bg-white">
          <div class="card-header">
            <h6 class="card-title">Total Bons (Livreur)</h6>
            <h6 class="mb-25 fw-black">
              {{ dashData?.total_l_payn ?? 0 }} Bons
            </h6>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-3 col-sm-6 mb-2">
                <div class="d-flex align-items-center">
                  <div
                    class="icon position-relative rounded-circle text-center bg-primary text-white me-15"
                    style="
                      width: 42px;
                      height: 42px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <i class="flaticon-sterile-box"></i>
                  </div>
                  <div>
                    <h6 class="mb-0 fw-medium">Total Colis</h6>
                    <small class="text-muted"
                      >{{ dashData?.total_l_parcels ?? 0 }} Colis</small
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-sm-6 mb-2">
                <div class="d-flex align-items-center">
                  <div
                    class="icon position-relative rounded-circle text-center bg-danger text-white me-15"
                    style="
                      width: 42px;
                      height: 42px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <i class="flaticon-money"></i>
                  </div>
                  <div>
                    <h6 class="mb-0 fw-medium">Total Crbt</h6>
                    <small class="text-muted">
                      {{ dashData?.total_l_crbt ?? 0 }}
                      {{ dashData?.devis?.devis ?? "" }}
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-sm-6 mb-2">
                <div class="d-flex align-items-center">
                  <div
                    class="icon position-relative rounded-circle text-center bg-secondary text-white me-15"
                    style="
                      width: 42px;
                      height: 42px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <i class="flaticon-express-delivery"></i>
                  </div>
                  <div>
                    <h6 class="mb-0 fw-medium">Total Frais</h6>
                    <small class="text-muted">
                      {{ dashData?.total_l_fees ?? 0 }}
                      {{ dashData?.devis?.devis ?? "" }}
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-sm-6 mb-2">
                <div class="d-flex align-items-center">
                  <div
                    class="icon position-relative rounded-circle text-center bg-info text-white me-15"
                    style="
                      width: 42px;
                      height: 42px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <i class="flaticon-money"></i>
                  </div>
                  <div>
                    <h6 class="mb-0 fw-medium">Total</h6>
                    <small class="text-muted">
                      {{ dashData?.total_l_total ?? 0 }}
                      {{ dashData?.devis?.devis ?? "" }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    <div class="col-12">
        <div v-if="dashData" class="card mb-25 border-0 rounded-0 bg-white">
            <div class="card-header">
                <h6 class="card-title">Total Bons (Zone)</h6>
                <h6 class="mb-25 fw-black">
                    {{ dashData?.total_z_payn ?? 0 }} Bons
                </h6>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-4 col-sm-6 mb-2">
                        <div class="d-flex align-items-center">
                            <div
                                class="icon position-relative rounded-circle text-center bg-primary text-white me-15"
                                style="
                                    width: 42px;
                                    height: 42px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                "
                            >
                                <i class="flaticon-sterile-box"></i>
                            </div>
                            <div>
                                <h6 class="mb-0 fw-medium">Total Colis</h6>
                                <small class="text-muted">
                                    {{ dashData?.total_z_parcels ?? 0 }} Colis
                                </small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6 mb-2">
                        <div class="d-flex align-items-center">
                            <div
                                class="icon position-relative rounded-circle text-center bg-secondary text-white me-15"
                                style="
                                    width: 42px;
                                    height: 42px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                "
                            >
                                <i class="flaticon-express-delivery"></i>
                            </div>
                            <div>
                                <h6 class="mb-0 fw-medium">Total Frais</h6>
                                <small class="text-muted">
                                    {{ dashData?.total_z_fees ?? 0 }}
                                    {{ dashData?.devis?.devis ?? "" }}
                                </small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6 mb-2">
                        <div class="d-flex align-items-center">
                            <div
                                class="icon position-relative rounded-circle text-center bg-info text-white me-15"
                                style="
                                    width: 42px;
                                    height: 42px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                "
                            >
                                <i class="flaticon-money"></i>
                            </div>
                            <div>
                                <h6 class="mb-0 fw-medium">Total</h6>
                                <small class="text-muted">
                                    {{ dashData?.total_z_total ?? 0 }}
                                    {{ dashData?.devis?.devis ?? "" }}
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
  </div>
  <div v-else class="row">
    <h3 class="mb-20">Statistiques Générals</h3>
    <div class="col-12">
      <div class="alert alert-info">Aucune donnée disponible.</div>
    </div>
  </div>
</template>
<script lang="ts">
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import { defineComponent, onMounted, ref } from "vue";

export default defineComponent({
  setup() {
    const dashData = ref<any>({});
    const auth = useAuthStore();
    const user = auth.user;

    const dd = ref([{ data: [] }]);

    const date_filter = ref("");
    const searchEDate = ref("");
    const searchSDate = ref("");

    const chartData = ref([
      {
        name: "Colis",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ]);
    const statisticsProfit = {
      chartOptions: {
        chart: {
          type: "line",
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        grid: {
          borderColor: "#e9ecef", // Replace $trackBgColor with a color value
          strokeDashArray: 5,
          xaxis: {
            lines: {
              show: true,
            },
          },
          yaxis: {
            lines: {
              show: false,
            },
          },
          padding: {
            top: -30,
            bottom: -10,
          },
        },
        stroke: {
          width: 3,
        },
        colors: ["#17a2b8"], // Replace $themeColors.info with a color value
        markers: {
          size: 2,
          colors: "#17a2b8",
          strokeColors: "#17a2b8",
          strokeWidth: 2,
          strokeOpacity: 1,
          strokeDashArray: 0,
          fillOpacity: 1,
          discrete: [
            {
              seriesIndex: 0,
              dataPointIndex: 5,
              fillColor: "#ffffff",
              strokeColor: "#17a2b8",
              size: 5,
            },
          ],
          shape: "circle",
          radius: 2,
          hover: {
            size: 3,
          },
        },
        xaxis: {
          labels: {
            show: true,
            style: {
              fontSize: "0px",
            },
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          show: false,
        },
        tooltip: {
          x: {
            show: false,
          },
        },
      },
    };

    const getData = async () => {
      await api
        .get(
          `/api/auth/StatisticParcels?user_id=${user?.id}&searchSDate=${searchSDate.value}&searchEDate=${searchEDate.value}`
        )
        .then((response: { data: any }) => {
          dashData.value = response.data;
          chartData.value[0].data = response.data.DataParcels;
          // dd.value[0].data = response.data.DataParcels;
          // isLoader.value = false;
        });
    };

    onMounted(() => {
      getData();
    });

    const FilterData = () => {
      getData();
    };

    const ClearFilterData = () => {
      searchEDate.value = "";
      searchSDate.value = "";
      getData();
    };

    return {
      dashData,
      dd,
      date_filter,
      searchEDate,
      searchSDate,
      getData,
      FilterData,
      ClearFilterData,
      chartData,
      statisticsProfit,
    };
  },
});
</script>
